import { Component, OnInit } from '@angular/core';
import { UserInterface } from './../../classes/userInterface';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'signed-out',
	template: require('./signed-out.component.html')
})
export class SignedOutComponent implements OnInit {
	public signedOutButtonRedirectUrl: string = AppSettings.signedOutButtonRedirectUrl;

	public ngOnInit(): void {
		UserInterface.header.title = 'You are signed out';
	}

	public redirectToIbank(): void {
		window.location.href = this.signedOutButtonRedirectUrl;
	}
}
